import React from "react";
import { Link } from "react-router-dom";
import {
    Clock, Camera, Car, Download, Image as ImageIcon, Plane, Zap, Sparkles, Video, MapPin,
    Heart, Users, Baby, Gift, Briefcase, Album, Mail, Cake,
} from "lucide-react";
import SEO from "../components/site/SEO";

/* --------- AUTOMOBILE --------- */
const AUTO_PACKS = [
    {
        key: "auto-decouverte",
        name: "Découverte",
        price: "99 €",
        items: [
            { icon: Clock, text: "30 à 45 min de shooting" },
            { icon: Camera, text: "10 photos retouchées HD" },
            { icon: Car, text: "1 véhicule" },
            { icon: Download, text: "Livraison sous 72h" },
        ],
        ideal: "Particuliers souhaitant quelques belles photos pour les réseaux sociaux ou la revente.",
    },
    {
        key: "auto-premium",
        name: "Premium",
        price: "199 €",
        featured: true,
        items: [
            { icon: Clock, text: "1h30 de shooting" },
            { icon: Camera, text: "25 photos retouchées HD" },
            { icon: Car, text: "Plusieurs angles et détails" },
            { icon: Download, text: "Livraison sous 72h" },
            { icon: ImageIcon, text: "Galerie privée en ligne" },
        ],
        ideal: "Propriétaires de véhicules sportifs, passionnés et collectionneurs.",
    },
    {
        key: "auto-prestige",
        name: "Prestige",
        price: "349 €",
        items: [
            { icon: Clock, text: "2h30 à 3h de shooting" },
            { icon: Camera, text: "50 photos retouchées HD" },
            { icon: MapPin, text: "Plusieurs lieux possibles" },
            { icon: Sparkles, text: "Photos de jour et/ou coucher de soleil" },
            { icon: ImageIcon, text: "Galerie privée premium" },
            { icon: Download, text: "Livraison sous 48h" },
        ],
        ideal: "Véhicules haut de gamme, clubs automobiles et contenu marketing.",
    },
];

const AUTO_PRO = [
    { icon: Car, title: "Pack stock véhicules", price: "15 €", unit: "/ photo retouchée", from: true },
    { icon: Camera, title: "Shooting véhicule premium", price: "250 €", unit: "/ véhicule", from: true },
    { icon: Clock, title: "Journée complète", price: "600 €", unit: "/ jour", from: false },
];

const AUTO_OPTIONS = [
    { icon: Plane, label: "Drone", price: "+80 €" },
    { icon: Zap, label: "Livraison express 24h", price: "+50 €" },
    { icon: Sparkles, label: "Retouche avancée", price: "+10 € / photo" },
    { icon: Video, label: "Vidéo Reel Instagram (15-30 sec)", price: "+90 €" },
    { icon: MapPin, label: "Déplacement > 30 km", price: "0,50 € / km" },
];

/* --------- MARIAGE --------- */
const MARIAGE_PACKS = [
    {
        key: "mariage-essentiel",
        name: "Essentiel",
        price: "690 €",
        items: [
            { icon: Clock, text: "3h de couverture (cérémonie + cocktail)" },
            { icon: Camera, text: "150 photos retouchées HD" },
            { icon: Heart, text: "Couple + invités" },
            { icon: ImageIcon, text: "Galerie privée en ligne" },
            { icon: Download, text: "Livraison sous 3 semaines" },
        ],
        ideal: "Couples avec cérémonie courte ou budget maîtrisé.",
    },
    {
        key: "mariage-complet",
        name: "Complet",
        price: "1 290 €",
        featured: true,
        items: [
            { icon: Clock, text: "8h de couverture (préparatifs → soirée)" },
            { icon: Camera, text: "350 photos retouchées HD" },
            { icon: Heart, text: "Préparatifs + cérémonie + cocktail + soirée" },
            { icon: MapPin, text: "Déplacement inclus jusqu'à 30 km" },
            { icon: ImageIcon, text: "Galerie privée premium" },
            { icon: Download, text: "Livraison sous 3 semaines" },
        ],
        ideal: "La formule la plus demandée — toute la journée capturée.",
    },
    {
        key: "mariage-prestige",
        name: "Prestige",
        price: "1 990 €",
        items: [
            { icon: Clock, text: "Journée complète + soirée jusqu'à minuit" },
            { icon: Camera, text: "500 photos retouchées HD" },
            { icon: Users, text: "Second photographe possible" },
            { icon: Video, text: "Vidéo Reel Instagram incluse" },
            { icon: Album, text: "Album imprimé 30 pages inclus" },
            { icon: Download, text: "Livraison express sous 2 semaines" },
        ],
        ideal: "Mariage haut de gamme — souvenir intemporel, livré clé en main.",
    },
];

const MARIAGE_OPTIONS = [
    { icon: Album, label: "Album imprimé 30 pages (haut de gamme)", price: "+250 €" },
    { icon: Users, label: "Second photographe (journée)", price: "+450 €" },
    { icon: Heart, label: "Séance engagement (avant le mariage)", price: "+180 €" },
    { icon: Plane, label: "Drone (selon réglementation)", price: "+150 €" },
    { icon: Video, label: "Vidéo Reel souvenirs (60-90 sec)", price: "+190 €" },
    { icon: MapPin, label: "Déplacement > 30 km", price: "0,50 € / km" },
];

/* --------- BAPTEME / FAMILLE --------- */
const BAPTEME_PACKS = [
    {
        key: "bapteme-decouverte",
        name: "Découverte",
        price: "290 €",
        items: [
            { icon: Clock, text: "1h30 de reportage" },
            { icon: Camera, text: "50 photos retouchées HD" },
            { icon: Baby, text: "Cérémonie OU portraits famille" },
            { icon: Download, text: "Livraison sous 10 jours" },
        ],
        ideal: "Couvrir l'essentiel de la cérémonie ou une séance famille rapide.",
    },
    {
        key: "bapteme-famille",
        name: "Famille",
        price: "490 €",
        featured: true,
        items: [
            { icon: Clock, text: "3h de reportage" },
            { icon: Camera, text: "100 photos retouchées HD" },
            { icon: Baby, text: "Cérémonie + portraits famille + détails" },
            { icon: ImageIcon, text: "Galerie privée en ligne" },
            { icon: Download, text: "Livraison sous 10 jours" },
        ],
        ideal: "Le format idéal pour un baptême complet ou un événement famille.",
    },
    {
        key: "bapteme-premium",
        name: "Premium",
        price: "790 €",
        items: [
            { icon: Clock, text: "Demi-journée (4-5h)" },
            { icon: Camera, text: "180 photos retouchées HD" },
            { icon: Baby, text: "Préparatifs + cérémonie + réception" },
            { icon: Album, text: "Album souvenir 20 pages inclus" },
            { icon: ImageIcon, text: "Galerie privée premium" },
            { icon: Download, text: "Livraison sous 10 jours" },
        ],
        ideal: "Pour garder une trace complète — du matin à la fin de la fête.",
    },
];

const BAPTEME_OPTIONS = [
    { icon: Album, label: "Album souvenir 20 pages", price: "+150 €" },
    { icon: Gift, label: "Tirages 10×15 (lot de 20)", price: "+45 €" },
    { icon: Heart, label: "Mini-séance famille additionnelle", price: "+120 €" },
    { icon: Video, label: "Vidéo Reel souvenir (30-60 sec)", price: "+120 €" },
    { icon: MapPin, label: "Déplacement > 30 km", price: "0,50 € / km" },
];

/* --------- AUTRES (portraits, événementiel, pro) --------- */
const AUTRES_PACKS = [
    {
        key: "autres-portrait",
        name: "Portrait",
        price: "149 €",
        items: [
            { icon: Clock, text: "1h de séance en extérieur ou studio" },
            { icon: Camera, text: "20 photos retouchées HD" },
            { icon: Users, text: "Solo, couple ou duo" },
            { icon: ImageIcon, text: "Galerie privée en ligne" },
            { icon: Download, text: "Livraison sous 7 jours" },
        ],
        ideal: "Portraits perso, réseaux sociaux, CV pro, book.",
    },
    {
        key: "autres-evenement",
        name: "Événement",
        price: "390 €",
        featured: true,
        items: [
            { icon: Clock, text: "3h sur place" },
            { icon: Camera, text: "120 photos retouchées HD" },
            { icon: Cake, text: "Anniversaire, EVJF/EVG, baby shower, fiançailles…" },
            { icon: ImageIcon, text: "Galerie privée en ligne" },
            { icon: Download, text: "Livraison sous 10 jours" },
        ],
        ideal: "Anniversaires, EVJF/EVG, fêtes privées.",
    },
    {
        key: "autres-pro",
        name: "Corporate / Pro",
        price: "Sur devis",
        items: [
            { icon: Briefcase, text: "Portraits collaborateurs, événements d'entreprise" },
            { icon: Camera, text: "Photos produits, locaux, équipe" },
            { icon: Video, text: "Vidéo & Reels disponibles" },
            { icon: Album, text: "Pack visuels prêts pour communication" },
        ],
        ideal: "Communication d'entreprise, LinkedIn, sites pro, brochures.",
    },
];

const AUTRES_OPTIONS = [
    { icon: Sparkles, label: "Retouche beauté avancée", price: "+15 € / photo" },
    { icon: Video, label: "Vidéo Reel (30-60 sec)", price: "+100 €" },
    { icon: Plane, label: "Drone (selon contexte)", price: "+80 €" },
    { icon: MapPin, label: "Déplacement > 30 km", price: "0,50 € / km" },
];

const CATEGORIES = [
    { key: "automobile", label: "Automobile", subtitle: "Photographie automobile", tagline: "Des images qui révèlent la puissance.", packs: AUTO_PACKS, pro: AUTO_PRO, options: AUTO_OPTIONS, contactType: "automobile" },
    { key: "mariage", label: "Mariage", subtitle: "Photographie de mariage", tagline: "Le jour qui ne reviendra pas.", packs: MARIAGE_PACKS, pro: null, options: MARIAGE_OPTIONS, contactType: "mariage" },
    { key: "bapteme", label: "Baptême & Famille", subtitle: "Cérémonies et famille", tagline: "Les premiers instants — et tous les suivants.", packs: BAPTEME_PACKS, pro: null, options: BAPTEME_OPTIONS, contactType: "bapteme" },
    { key: "autres", label: "Portrait & Autres", subtitle: "Portraits, événements, pro", tagline: "Chaque histoire mérite son cliché.", packs: AUTRES_PACKS, pro: null, options: AUTRES_OPTIONS, contactType: "autres" },
];

export default function Tarifs() {
    const [active, setActive] = React.useState("automobile");
    const current = CATEGORIES.find((c) => c.key === active);

    React.useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [active]);

    return (
        <div data-testid="page-tarifs" className="pt-32 pb-24 px-6 md:px-12 lg:px-24">
            <SEO title="Tarifs" description="Tarifs photographie : automobile, mariage, baptême, portraits. Packs détaillés et options pour chaque prestation." />

            {/* Header */}
            <div className="mb-12 max-w-3xl">
                <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">— Tarifs / {current.subtitle}</p>
                <h1 className="font-serif-display text-5xl md:text-7xl">
                    {current.tagline}
                </h1>
                <p className="text-zinc-400 mt-6 leading-relaxed">
                    Des packs clairs, des options à la carte, et toujours un devis personnalisé si besoin.
                </p>
            </div>

            {/* Category tabs */}
            <div data-testid="tarifs-tabs" className="flex flex-wrap gap-2 mb-16 border-b border-white/10 pb-6">
                {CATEGORIES.map((c) => (
                    <button
                        key={c.key}
                        data-testid={`tarifs-tab-${c.key}`}
                        onClick={() => setActive(c.key)}
                        className={`px-5 py-2 text-xs uppercase tracking-[0.2em] border transition-colors ${
                            active === c.key
                                ? "bg-[#c5a059] text-black border-[#c5a059]"
                                : "border-white/15 text-zinc-300 hover:text-white hover:border-white/40"
                        }`}
                    >
                        {c.label}
                    </button>
                ))}
            </div>

            {/* Packs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {current.packs.map((p) => (
                    <div
                        key={p.key}
                        data-testid={`pack-${p.key}`}
                        className={`relative border p-8 transition-all duration-300 hover:-translate-y-1 ${
                            p.featured
                                ? "border-[#c5a059] bg-[#0f0d08]"
                                : "border-white/10 bg-[#0f0f0f] hover:border-white/30"
                        }`}
                    >
                        {p.featured && (
                            <div className="absolute -top-3 left-8 bg-[#c5a059] text-black text-xs uppercase tracking-[0.2em] px-3 py-1">
                                Populaire
                            </div>
                        )}
                        <p className="text-xs uppercase tracking-[0.3em] text-zinc-500">Pack</p>
                        <h3 className="font-serif-display text-4xl mt-2 uppercase">{p.name}</h3>
                        <p className="text-[#c5a059] text-5xl font-semibold tracking-tight mt-4">{p.price}</p>
                        <ul className="mt-8 space-y-3 border-t border-white/10 pt-6">
                            {p.items.map((item, i) => (
                                <li key={i} className="flex gap-3 text-zinc-300 text-sm leading-relaxed">
                                    <item.icon size={16} strokeWidth={1.5} className="text-[#c5a059] shrink-0 mt-0.5" />
                                    {item.text}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-8 border-t border-white/10 pt-6">
                            <p className="text-xs uppercase tracking-[0.25em] text-[#c5a059] mb-2">Idéal pour</p>
                            <p className="text-zinc-400 text-sm leading-relaxed">{p.ideal}</p>
                        </div>
                        <Link
                            to={`/contact?type=${current.contactType}`}
                            data-testid={`pack-cta-${p.key}`}
                            className={`mt-8 inline-flex w-full justify-center px-6 py-3 uppercase tracking-[0.18em] text-xs transition-colors ${
                                p.featured
                                    ? "bg-[#c5a059] text-black hover:bg-[#dcc082]"
                                    : "border border-white/20 text-white hover:bg-white hover:text-black"
                            }`}
                        >
                            Réserver
                        </Link>
                    </div>
                ))}
            </div>

            {/* Pro (automobile only) */}
            {current.pro && (
                <div className="mt-16 border border-white/10 bg-[#0f0f0f] p-8 md:p-12">
                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
                        <div>
                            <p className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-2">Concessionnaires / Garages</p>
                            <h2 className="font-serif-display text-3xl">Prestations<br /><span className="text-[#c5a059]">professionnelles</span></h2>
                            <p className="text-zinc-400 text-sm mt-4 leading-relaxed">
                                Des solutions adaptées aux professionnels de l'automobile.
                            </p>
                        </div>
                        {current.pro.map((it) => (
                            <div key={it.title} className="border-l border-white/10 pl-6 first:lg:border-l-0 first:lg:pl-0">
                                <it.icon size={28} strokeWidth={1.5} className="text-[#c5a059]" />
                                <p className="text-xs uppercase tracking-[0.22em] text-zinc-300 mt-4">{it.title}</p>
                                {it.from && <p className="text-zinc-500 text-xs mt-2">À partir de</p>}
                                <p className="text-3xl font-semibold tracking-tight mt-1">
                                    <span className="text-[#c5a059]">{it.price}</span>
                                    <span className="text-zinc-400 text-sm font-normal ml-2">{it.unit}</span>
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Options + Offre */}
            <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
                <div className="lg:col-span-2 border border-white/10 bg-[#0f0f0f] p-8 md:p-10">
                    <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-2">— Options</p>
                    <h3 className="font-serif-display text-3xl mb-6">À ajouter selon vos besoins</h3>
                    <ul className="divide-y divide-white/10">
                        {current.options.map((opt) => (
                            <li key={opt.label} className="flex items-center justify-between py-3 gap-4">
                                <span className="flex items-center gap-3 text-zinc-300 text-sm">
                                    <opt.icon size={16} strokeWidth={1.5} className="text-[#c5a059] shrink-0" />
                                    {opt.label}
                                </span>
                                <span className="text-[#c5a059] text-sm whitespace-nowrap">{opt.price}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                <div data-testid="offre-lancement" className="border border-[#c5a059] bg-gradient-to-b from-[#1a1408] to-[#0f0d08] p-8 md:p-10 flex flex-col justify-between">
                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-[#c5a059] mb-2">Offre de lancement</p>
                        <h3 className="text-7xl font-bold tracking-tight text-white">-20%</h3>
                        <p className="text-zinc-300 text-sm uppercase tracking-[0.18em] mt-3">Sur votre première prestation</p>
                        <p className="text-zinc-400 text-sm mt-4">
                            Valable sur l'ensemble des packs — mariage, automobile, baptême et portraits.
                        </p>
                    </div>
                    <Link
                        to={`/contact?type=${current.contactType}`}
                        data-testid="offre-cta"
                        className="mt-8 inline-flex justify-center bg-[#c5a059] text-black px-6 py-3 uppercase tracking-[0.18em] text-xs hover:bg-[#dcc082] transition-colors"
                    >
                        J'en profite
                    </Link>
                </div>
            </div>

            {/* Trust band */}
            <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 border-t border-white/10 pt-10">
                {[
                    { icon: Camera, t: "Matériel professionnel" },
                    { icon: Sparkles, t: "Assurance professionnelle" },
                    { icon: Zap, t: "Livraison rapide et soignée" },
                    { icon: Mail, t: "Devis gratuit sous 48h" },
                ].map((b) => (
                    <div key={b.t} className="flex items-center gap-3">
                        <b.icon size={20} strokeWidth={1.5} className="text-[#c5a059]" />
                        <span className="text-xs uppercase tracking-[0.2em] text-zinc-300">{b.t}</span>
                    </div>
                ))}
            </div>

            {/* CTA bottom */}
            <div className="mt-20 border-t border-white/10 pt-12 text-center">
                <p className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">— Une demande particulière ?</p>
                <h3 className="font-serif-display text-3xl md:text-4xl">Chaque projet est unique.</h3>
                <p className="text-zinc-400 mt-4 max-w-xl mx-auto">
                    Ces tarifs sont des bases — discutons de votre projet pour adapter une formule sur mesure.
                </p>
                <Link
                    to="/contact"
                    data-testid="autres-cta"
                    className="mt-8 inline-flex border border-white/20 text-white px-8 py-3 uppercase tracking-[0.18em] text-xs hover:bg-white hover:text-black transition-colors"
                >
                    Demander un devis sur mesure
                </Link>
            </div>
        </div>
    );
}
